export const newsData = [
  {
    id: 1,
    img: "/images/doc5.png",
    admin: 'My Admin',
    date: '25 Dec 2022',
    title: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem.",
    description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt suscipit nulla rem repellat reiciendis impedit autem voluptas commodi, non doloribus.",
    btn: 'Read More',
  },
  {
    id: 2,
    img: "/images/doc6.png",
    admin: 'My Admin',
    date: '25 Dec 2022',
    title: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem.",
    description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt suscipit nulla rem repellat reiciendis impedit autem voluptas commodi, non doloribus.",
    btn: 'Read More',
  },
  {
    id: 3,
    img: "/images/doc8.png",
    admin: 'My Admin',
    date: '25 Dec 2022',
    title: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Autem.",
    description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt suscipit nulla rem repellat reiciendis impedit autem voluptas commodi, non doloribus.",
    btn: 'Read More',
  },
 
];
